import { useLocalSearchParams } from 'expo-router';

import Explainer from '../../../../banking/components/direct-deposit/Explainer';
import type { DirectDepositSwitchAppContext } from '../../../../banking/components/direct-deposit/types';

const Info = () => {
    const { context, source } = useLocalSearchParams<{
        context?: DirectDepositSwitchAppContext;
        source?: string;
    }>();

    return <Explainer context={context} source={source} />;
};

export default Info;
